module.exports = __webpack_public_path__ + "static/img/icon-info.b925bb6e.svg";